import { RootState } from 'src/store';

export const getProductsCatalogState = (state: Pick<RootState, 'productsCatalog'>) =>
    state.productsCatalog;
